import { gql } from "@apollo/client";
import { DepartmentNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const QueryDepartments = gql`
  ${DepartmentNoNestingFragment}
  query QueryDepartments($options: DepartmentListOptions) {
    departments(options: $options) {
      items {
        ...DepartmentNoNesting
      }
    }
  }
`;

export const DEFAULT_DEPARTMENTS_OPTIONS = {
  limit: 10,
  page: 1,
  includeDeleted: false,
  sort: { name: "ASC" },
};
